import { ICallStatus } from "buddy-api/types/callstatus";
import ApiMixin from "../ApiMixin";

export default class CallStatusAPI extends ApiMixin<ICallStatus> {}
